export const NICKNAME_MIN_LENGTH = 3;
export const NICKNAME_MAX_LENGTH = 30;
export const NICKNAME_INPUT_PATTERN = /^[a-zA-Z0-9_\s]*$/;

/** API/storage format: trim, spaces → underscores, collapse repeats. */
export function normalizeNicknameForApi(value) {
  return String(value ?? "")
    .trim()
    .replace(/\s+/g, "_")
    .replace(/_+/g, "_")
    .replace(/^_+|_+$/g, "");
}

/** UI display: underscores → spaces. */
export function formatNicknameForDisplay(value) {
  return String(value ?? "")
    .replace(/_/g, " ")
    .trim();
}

export function isNicknameInputAllowed(value) {
  if (!value) return true;
  return NICKNAME_INPUT_PATTERN.test(value);
}

export function getNicknameValidationError(value, initialNickname) {
  const trimmed = String(value ?? "").trim();
  if (!trimmed) return "Enter a nickname.";
  if (!isNicknameInputAllowed(trimmed)) {
    return "Use only letters, numbers, spaces, or underscores.";
  }

  const normalized = normalizeNicknameForApi(trimmed);
  if (normalized.length < NICKNAME_MIN_LENGTH) {
    return `Use at least ${NICKNAME_MIN_LENGTH} characters.`;
  }
  if (normalized.length > NICKNAME_MAX_LENGTH) {
    return `Nickname must be ${NICKNAME_MAX_LENGTH} characters or fewer.`;
  }

  const initialNormalized = normalizeNicknameForApi(initialNickname);
  if (normalized === initialNormalized) {
    return "Change the nickname to something new to save.";
  }

  return "";
}
